// extracted by mini-css-extract-plugin
module.exports = {"container":"forgot-password_container__2PAnB","wrapper":"forgot-password_wrapper__2AMTz"};